// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container {\n  background-color: #f5f5f5;\n  height: 100vh;\n}\n.page-tottom-tabbar {\n  width: 100%;\n  max-width: 10rem;\n  left: auto !important;\n}\nimg {\n  max-width: 100% !important;\n  height: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
